/**
 * When set to "1", the next mount of the portal-config questionnaire will clear
 * stored PortalConfigAnswers (`[]`) on the server (dashboard re-opened the isHistory task).
 */
export const SESSION_PORTAL_CONFIG_RESET_PENDING = 'hct_portalConfigResetFromDashboard'
